/* eslint-disable */
import './AreaIndicatorCard.css';

import React, { useContext, useEffect, useState } from 'react';
import { IndicatorCardCommonDetails, QualitativeIndicatorDetails, QuantitativeDimensionalIndicatorDetails, QuantitativeIndicatorDetails } from '../../../b2b-indicators/components/IndicatorCard';
import { Box, Divider } from '@mui/material';
import { getCurrentObjective } from '../helper';
import MoreButton from '../../../b2b-common/MoreButton';
import { AdsClick, AutoStories, ContentCopy, DashboardCustomize, DataArray, Delete, Edit, MoreVert, SwapHoriz } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { LoginContext } from '../../../../App';
import { deleteAreaIndicator } from '../../../../services/b2b-plans-apiService';
import CronExpressionField from '../CronExpressionField';
import Banner from '../../../b2b-common/Banner';
import { WeightRatingField } from './WeightRating';
import AccessLevel from '../AccessLevel';
import { IndicatorIcon } from '../../../b2b-indicators/components/indicatorHelpers';
import ObjectivesManagementModal from '../../forms/ObjectivesManagementModal';
import SamplesManagementModal from '../../forms/SamplesManagementModal';
import { B2BContentContext } from '../../../layout/Layout';
import { showNotification } from '../../../b2b-common/Notification';
import Counter from '../../../b2b-common/Counter';
import AreaIndicatorWidgetModal from '../../../b2b-reporting/forms/AreaIndicatorWidgetModal';
import { generateClassName } from '../../../b2b-common/helpers';
import AreaIndicatorChartFactory from './chart/AreaIndicatorChartFactory';
import ConfirmationDialog from '../../../b2b-common/ConfirmationDialog';
import LogbookModalFactory from '../../../b2b-logbook/forms/LogbookModalFactory';
import useB2BTranslation from '../../../b2b-common/hooks/useB2BTranslation';
import ShowHideSection from '../../../b2b-common/ShowHideSection';
import IndicatorWithTooltipInfo from '../../../b2b-indicators/components/IndicatorWithTooltipInfo';
import FullStatus from '../plans/FullStatus';
import useDashboardsData from '../../hooks/useDashboardsData';
import AreaIndicatorDashboardsCounter from './AreaIndicatorDashboardsCounter';
import ObjectiveDetails from '../objectives/ObjectiveDetails';
import WarningWithAction from '../../../b2b-common/WarningWithAction';
import IndicatorImpact from '../../../b2b-frameworks/components/framework-impact/IndicatorImpact';
import useGettingAvailableWidgetTemplates from '../../../b2b-reporting/hooks/useGettingAvailableWidgetTemplates';
import { use_AREA_INDICATOR_eligibilityHelper } from '../../../b2b-reporting/hooks/use_AREA_INDICATOR_eligibilityHelper';
import { isEqual } from 'lodash';
import AreaIndicatorCopyModal from '../../forms/AreaIndicatorCopyModal';
import AreaIndicatorMoveModal from '../../forms/AreaIndicatorMoveModal';

export const IndicatorDetails = ({ indicator, showDescription = true }) => {
    return (
        <>
            <IndicatorCardCommonDetails indicator={indicator} showDescription={showDescription} />
            <Divider />
            {
                indicator.indicatorDTOType === 'QUANTITATIVE' && (
                    <QuantitativeIndicatorDetails indicator={indicator} />
                )
            }
            {
                indicator.indicatorDTOType === 'QUALITATIVE' && (
                    <QualitativeIndicatorDetails indicator={indicator} />
                )
            }
            {
                indicator.indicatorDTOType === 'QUANTITATIVE_DIMENSIONAL' && (
                    <QuantitativeDimensionalIndicatorDetails indicator={indicator} />
                )
            }
            <div className='area-indicator-card-indicator-frameworks'>
                {/* TO BE DONE */}
            </div>
        </>
    );
}

export const AreaIndicatorMainDetails = ({ areaIndicatorData, dashboardsData, className, showAccessLevel = false }) => {
    const { t } = useB2BTranslation('b2b-plans');
    const [currentDashboardsData, setCurrentDashboardsData] = useState(null);

    useEffect(() => {
        if (dashboardsData && !isEqual(dashboardsData, currentDashboardsData)) {
            setCurrentDashboardsData(dashboardsData);
        }
    }, [dashboardsData]);

    return (
        areaIndicatorData && (
            <Box className={generateClassName('area-indicator-card-details', '-main', className)} width='100%' p='0 10px' boxSizing='border-box' >
                {!areaIndicatorData.indicatorDTO.automaticSampling && (
                    <CronExpressionField cronExpression={areaIndicatorData.samplingPeriodCronExpression} />
                )}
                <WeightRatingField weight={areaIndicatorData.areaIndicatorWeight} />
                {showAccessLevel && (
                    <AccessLevel readOnly={areaIndicatorData.readOnly} />
                )}
                <Counter label={t('All Samples')} count={areaIndicatorData.sampleDTOs.length} minDigits={2} />
                {currentDashboardsData && (
                    <AreaIndicatorDashboardsCounter dashboardsData={currentDashboardsData} />
                )}
            </Box>
        )
    );
}

const AreaIndicatorName = ({ areaIndicatorName }) => {
    return (
        <Box className='area-indicator-card-name'
            boxSizing='border-box' pl='10px' pr='10px' width='100%' display='flex' justifyContent='space-between' alignItems='center'
        >
            <Box className='area-indicator-card-name-text' whiteSpace='nowrap' overflow='hidden' textOverflow='ellipsis'>
                {areaIndicatorName}
            </Box>
        </Box>
    );
};

const AreaIndicatorCard = ({ areaIndicator: areaIndicatorData, onDelete = null, onRefresh = null }) => {
    const { t } = useB2BTranslation('b2b-plans');
    const navigate = useNavigate();
    const { loginData } = useContext(LoginContext);
    const { setNotification } = useContext(B2BContentContext);
    const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
    const [currentAreaIndicator, setCurrentAreaIndicator] = useState(areaIndicatorData);
    const [currentObjective, setCurrentObjective] = useState(getCurrentObjective(areaIndicatorData.objectiveDTOs));

    const [showObjectivesModal, setShowObjectivesModal] = useState(false);
    const [showSamplesModal, setShowSamplesModal] = useState(false);
    const [showCopyAreaIndicatorModal, setShowCopyAreaIndicatorModal] = useState(false);
    const [showMoveAreaIndicatorModal, setShowMoveAreaIndicatorModal] = useState(false);
    const [showWidgetModal, setShowWidgetModal] = useState(false);
    const [showLogbookModal, setShowLogbookModal] = useState(false);

    const [dashboardsData, getDashboardsData] = useDashboardsData(areaIndicatorData);
    const { availableWidgetTemplates } = useGettingAvailableWidgetTemplates('AREA_INDICATOR');
    const { getApplicableTemplates } = use_AREA_INDICATOR_eligibilityHelper();

    const applicableWidgetTemplates = getApplicableTemplates(
        availableWidgetTemplates || [],
        areaIndicatorData
    );

    useEffect(() => {
        if (areaIndicatorData !== currentAreaIndicator) {
            setCurrentAreaIndicator(areaIndicatorData);
            setCurrentObjective(getCurrentObjective(areaIndicatorData.objectiveDTOs));
            getDashboardsData();
        }
    }, [areaIndicatorData]);

    const handleEditAreaIndicator = () => {
        // console.log('Edit area indicator clicked: ', areaIndicatorData);
        navigate(`/plans/plans-explorer/${currentAreaIndicator.area.plan.planUUID}/${currentAreaIndicator.area.areaId}/areaIndicatorEdit`,
            {
                state: {
                    plan: currentAreaIndicator.area.plan,
                    area: currentAreaIndicator.area,
                    areaIndicator: currentAreaIndicator,
                    from: `/plans/plans-explorer/${currentAreaIndicator.area.plan.planUUID}`
                }
            });
    }

    const handleDeleteConfirmation = async () => {
        try {
            // console.log('Delete area indicator clicked: ', areaIndicatorData);
            await deleteAreaIndicator(loginData.accessToken, currentAreaIndicator.area.plan.planUUID, currentAreaIndicator.area.areaId, currentAreaIndicator.areaIndicatorId);
            // console.log('deleteAreaIndicator response:', response);
            showNotification(setNotification, t('Area indicator deleted successfully'), 'success', 3000);
            onDelete && onDelete(currentAreaIndicator.areaIndicatorId);
        } catch (error) {
            // setError(error.message);
            console.error('deleteAreaIndicator error:', error);
            showNotification(setNotification, t('Error deleting area indicator: ') + error.message, 'error', 3000);
        } finally {
            setIsConfirmationOpen(false);
        }
    }

    const handleSavedWidget = async () => {
        setShowWidgetModal(false);
        getDashboardsData();
    }

    const showAddToDashboard = applicableWidgetTemplates && applicableWidgetTemplates.length > 0;

    return (
        <div className='area-indicator-card-container'>
            <AreaIndicatorName areaIndicatorName={currentAreaIndicator.areaIndicatorName} />
            <IndicatorWithTooltipInfo indicator={currentAreaIndicator.indicatorDTO} />
            <AreaIndicatorMainDetails areaIndicatorData={currentAreaIndicator} dashboardsData={dashboardsData} />
            {((currentAreaIndicator.objectiveDTOs.length === 0) || (currentAreaIndicator.sampleDTOs.length === 0)) && (
                currentAreaIndicator.objectiveDTOs.length === 0 ? (
                    <WarningWithAction message={t('No objectives defined for this area indicator.')}
                        actionLabel={t('Define objectives')} onAction={() => setShowObjectivesModal(true)}
                        className={'area-indicator-card-no-objectives-warning'}
                        bgColor='#2BB8C8'
                    />
                ) : (
                    <WarningWithAction message={t('No samples have been entered.')}
                        actionLabel={t('Create samples')} onAction={() => setShowSamplesModal(true)}
                        className={'area-indicator-card-no-objectives-warning'}
                        bgColor='#3233c1'
                    />
                ))}
            {((currentAreaIndicator.objectiveDTOs.length > 0) && (currentAreaIndicator.sampleDTOs.length > 0)) && (
                <>
                    <FullStatus label={t('Current objective status')}
                        status={currentAreaIndicator.status} trend={currentAreaIndicator.trend} progress={currentAreaIndicator.progress}
                        startDate={currentObjective?.startDate} endDate={currentObjective?.endDate}
                        className={'area-indicator-card-status-trend-progress'}
                    />
                    <ShowHideSection open={false} setOpen={() => { }}
                        header={
                            <Box display='flex' flexDirection='row' alignItems='center' justifyContent='space-between' width={'100%'} >
                                <Box>
                                    <IndicatorImpact frameworkSuite={'generic'} frameworkId={2} indicator={currentAreaIndicator.indicatorDTO} className={'area-indicator-card-impact'} />
                                </Box>
                                <Box display='flex' flexDirection='row' alignItems='center' justifyContent='center' gap={1}>
                                    <IndicatorIcon indicator={currentAreaIndicator.indicatorDTO} />
                                    <Banner message={t('Area indicator details')} headingLevel='h4' underline={false} />
                                </Box>
                            </Box>
                        }
                        className={'area-indicator-card-show-hide'}
                    >
                        <AreaIndicatorChartFactory areaIndicator={currentAreaIndicator} />
                        <ObjectiveDetails areaIndicator={currentAreaIndicator} />
                    </ShowHideSection>
                </>
            )}
            <div className='area-indicator-card-actions'>
                <MoreButton icon={<MoreVert />} buttons={[
                    {
                        label: t('Edit'),
                        icon: <Edit />,
                        rolesAllowed: ['ADMIN', 'EDITOR'],
                        confirm: false,
                        onClick: handleEditAreaIndicator,
                    },
                    {
                        label: t('Objectives'),
                        icon: <AdsClick />,
                        rolesAllowed: ['ADMIN', 'EDITOR'],
                        confirm: false,
                        onClick: () => setShowObjectivesModal(true)
                    },
                    {
                        label: t('Samples'),
                        icon: <DataArray />,
                        rolesAllowed: ['ADMIN', 'EDITOR'],
                        confirm: false,
                        onClick: () => setShowSamplesModal(true)
                    },
                    {
                        label: t('Copy Area Indicator'),
                        icon: <ContentCopy />,
                        rolesAllowed: ['ADMIN', 'EDITOR'],
                        confirm: false,
                        onClick: () => setShowCopyAreaIndicatorModal(true)
                    },
                    {
                        label: t('Move Area Indicator'),
                        icon: <SwapHoriz />,
                        rolesAllowed: ['ADMIN', 'EDITOR'],
                        confirm: false,
                        onClick: () => setShowMoveAreaIndicatorModal(true)
                    },
                    ...(showAddToDashboard ? [{
                        label: t('Add to Dashboards'),
                        icon: <DashboardCustomize />,
                        rolesAllowed: ['ADMIN', 'EDITOR'],
                        b2bProducts: ['B2B_CUSTOM_DASHBOARDS'],
                        confirm: false,
                        onClick: () => setShowWidgetModal(true)
                    }] : []),
                    {
                        label: t('Logbook'),
                        icon: <AutoStories />,
                        rolesAllowed: [],
                        b2bProducts: ['B2B_LOGBOOK'],
                        confirm: false,
                        onClick: () => setShowLogbookModal(true)
                    },
                    {
                        label: t('Delete'),
                        icon: <Delete />,
                        rolesAllowed: ['ADMIN', 'EDITOR'],
                        onClick: () => setIsConfirmationOpen(true)
                    },
                ]}
                    rolesAllowed={['ADMIN', 'EDITOR', 'USER']}
                    className={'area-indicator-card-more-button jb01-more-button'}
                />
            </div>
            <ObjectivesManagementModal open={showObjectivesModal} areaIndicator={currentAreaIndicator}
                onClose={() => setShowObjectivesModal(false)}
                onRefresh={onRefresh}
            />
            <SamplesManagementModal open={showSamplesModal} areaIndicator={currentAreaIndicator}
                onClose={() => setShowSamplesModal(false)}
                onRefresh={onRefresh}
            />
            <AreaIndicatorWidgetModal open={showWidgetModal} areaIndicator={currentAreaIndicator}
                onCancel={() => setShowWidgetModal(false)}
                onSaved={handleSavedWidget}
            />
            {showCopyAreaIndicatorModal && (
                <AreaIndicatorCopyModal open={showCopyAreaIndicatorModal} areaIndicator={currentAreaIndicator}
                    onClose={() => setShowCopyAreaIndicatorModal(false)}
                    onRefresh={onRefresh}
                />
            )}
            {showMoveAreaIndicatorModal && (
                <AreaIndicatorMoveModal open={showMoveAreaIndicatorModal} areaIndicator={currentAreaIndicator}
                    onClose={() => setShowMoveAreaIndicatorModal(false)}
                    onRefresh={onRefresh}
                    isMoveMode={true}
                />
            )}
            <LogbookModalFactory logbookRelatedEntity={currentAreaIndicator} open={showLogbookModal}
                onClose={() => { setShowLogbookModal(false) }} />
            <ConfirmationDialog
                title={t('Area-Indicator Delete Confirmation Request')}
                mainText={t('Are you sure you want to delete the selected area-indicator?')}
                open={isConfirmationOpen}
                onClose={() => setIsConfirmationOpen(false)}
                onConfirm={handleDeleteConfirmation}
            />
        </div>
    );
};

export default AreaIndicatorCard;